// GoodWe ESA G20 Battery Packages — fully supplied + installed bundles.
//
// IMPORTANT (customer-facing pricing rule):
//   Every price below is the CUSTOMER OUT-OF-POCKET price AFTER the estimated
//   BSTC (Battery STC) discount, based on standard installation conditions.
//   No unit prices, inverter prices, module prices, supplier costs or internal
//   cost breakdowns are stored or displayed anywhere.
//
// Packages use GoodWe ESA G20 battery modules ONLY (never G21), and a single
// stack must use one module type only — 5.12 kWh OR 8.32 kWh, never mixed.
// Only packages up to ~50 kWh are listed.

// --- GoodWe ESA hybrid inverter options (no prices shown) ---
export const GOODWE_INVERTERS = [
  { id: '5kw-1p', label: '5 kW 1P', short: '5 kW Single-Phase', phase: 1, model: 'GW5K-EHA-G20' },
  { id: '5kw-3p', label: '5 kW 3P', short: '5 kW Three-Phase', phase: 3, model: 'GW5K-ETA-G20' },
  { id: '8kw-1p', label: '8 kW 1P', short: '8 kW Single-Phase', phase: 1, model: 'GW8K-EHA-G20' },
  { id: '9.99kw-1p', label: '9.99 kW 1P', short: '9.99 kW Single-Phase', phase: 1, model: 'GW9.999K-EHA-G20' },
  { id: '9.99kw-3p', label: '9.99 kW 3P', short: '9.99 kW Three-Phase', phase: 3, model: 'GW9.999K-ETA-G20' },
  { id: '15kw-3p', label: '15 kW 3P', short: '15 kW Three-Phase', phase: 3, model: 'GW15K-ETA-G20' },
  { id: '20kw-3p', label: '20 kW 3P', short: '20 kW Three-Phase', phase: 3, model: 'GW20K-ETA-G20' },
  { id: '25kw-3p', label: '25 kW 3P', short: '25 kW Three-Phase', phase: 3, model: 'GW25K-ETA-G20' },
  { id: '29.999kw-3p', label: '29.999 kW 3P', short: '29.999 kW Three-Phase', phase: 3, model: 'GW29.9K-ETA-G20' },
];

const P = (a, b, c, d, e, f, g, h, i) => ({
  '5kw-1p': a,
  '5kw-3p': b,
  '8kw-1p': c,
  '9.99kw-1p': d,
  '9.99kw-3p': e,
  '15kw-3p': f,
  '20kw-3p': g,
  '25kw-3p': h,
  '29.999kw-3p': i,
});

// --- G20 5.12 kWh module packages (max 9 modules / 46.08 kWh) ---
const PACKAGES_512 = [
  { kwh: 5.12, modules: 1, bstcQty: 34, bstcDiscount: 1258, prices: P(5901, 6655, 6533, 6684, 6817, 6954, 7348, 7458, 7568) },
  { kwh: 10.24, modules: 2, bstcQty: 68, bstcDiscount: 2516, prices: P(6243, 6998, 6876, 7027, 7160, 7296, 7691, 7801, 7911) },
  { kwh: 15.36, modules: 3, bstcQty: 99, bstcDiscount: 3663, prices: P(6697, 7451, 7329, 7480, 7613, 7750, 8144, 8254, 8364) },
  { kwh: 20.48, modules: 4, bstcQty: 119, bstcDiscount: 4403, prices: P(7557, 8312, 8190, 8341, 8474, 8610, 9005, 9115, 9225) },
  { kwh: 25.6, modules: 5, bstcQty: 140, bstcDiscount: 5180, prices: P(8381, 9135, 9013, 9164, 9297, 9434, 9828, 9938, 10048) },
  { kwh: 30.72, modules: 6, bstcQty: 154, bstcDiscount: 5698, prices: P(9463, 10218, 10096, 10247, 10380, 10516, 10911, 11021, 11131) },
  { kwh: 35.84, modules: 7, bstcQty: 159, bstcDiscount: 5883, prices: P(null, 11633, null, null, 11795, 11932, 12326, 12436, 12546) },
  { kwh: 40.96, modules: 8, bstcQty: 164, bstcDiscount: 6068, prices: P(null, 13049, null, null, 13211, 13347, 13742, 13852, 13962) },
  { kwh: 46.08, modules: 9, bstcQty: 169, bstcDiscount: 6253, prices: P(null, 14464, null, null, 14626, 14763, 15157, 15267, 15377) },
];

// --- G20 8.32 kWh module packages (max 6 modules / 49.92 kWh) ---
const PACKAGES_832 = [
  { kwh: 8.32, modules: 1, bstcQty: 54, bstcDiscount: 1998, prices: P(5947, 6702, 6580, 6731, 6864, 7000, 7395, 7505, 7615) },
  { kwh: 16.64, modules: 2, bstcQty: 103, bstcDiscount: 3811, prices: P(6521, 7276, 7154, 7305, 7438, 7574, 7969, 8079, 8189) },
  { kwh: 24.96, modules: 3, bstcQty: 136, bstcDiscount: 5032, prices: P(7687, 8442, 8320, 8471, 8604, 8740, 9135, 9245, 9355) },
  { kwh: 33.28, modules: 4, bstcQty: 156, bstcDiscount: 5772, prices: P(9334, 10089, 9967, 10118, 10251, 10387, 10782, 10892, 11002) },
  { kwh: 41.6, modules: 5, bstcQty: 164, bstcDiscount: 6068, prices: P(11425, 12180, 12058, 12209, 12342, 12478, 12873, 12983, 13093) },
  { kwh: 49.92, modules: 6, bstcQty: 172, bstcDiscount: 6364, prices: P(13516, 14271, 14149, 14300, 14433, 14569, 14964, 15074, 15184) },
];

const kwhToSlug = (kwh) =>
  `goodwe-g20-${kwh.toFixed(2).replace('.', '-')}kwh-battery-package`;

const build = (rows, moduleType) =>
  rows.map((r) => ({
    ...r,
    slug: kwhToSlug(r.kwh),
    moduleType, // '5.12' | '8.32'
    name: `GoodWe G20 ${r.kwh.toFixed(2)} kWh Battery Package`,
  }));

export const GOODWE_PACKAGES = [
  ...build(PACKAGES_512, '5.12'),
  ...build(PACKAGES_832, '8.32'),
];

export const GOODWE_PACKAGES_512 = GOODWE_PACKAGES.filter((p) => p.moduleType === '5.12');
export const GOODWE_PACKAGES_832 = GOODWE_PACKAGES.filter((p) => p.moduleType === '8.32');

export const getGoodwePackage = (slug) => GOODWE_PACKAGES.find((p) => p.slug === slug);

// Lowest available out-of-pocket price (ignores N/A inverter options).
export const startingPrice = (pkg) =>
  Math.min(...Object.values(pkg.prices).filter((v) => v != null));

// Inverter options that are available (priced) for a given package.
export const availableInverters = (pkg) =>
  GOODWE_INVERTERS.filter((inv) => pkg.prices[inv.id] != null);

export const fmtAUD = (n) => `$${Math.round(n).toLocaleString('en-AU')}`;

// --- Content for the main overview page ---
export const GOODWE_MODULE_INFO = {
  '5.12': {
    label: 'G20 5.12 kWh',
    usable: '5.0 kWh usable',
    bestFor: 'Finer capacity steps — ideal for tailoring storage in 5.12 kWh increments up to 46.08 kWh.',
    maxModules: 9,
  },
  '8.32': {
    label: 'G20 8.32 kWh',
    usable: '8.0 kWh usable',
    bestFor: 'Bigger capacity per module — reach higher storage with fewer modules, up to 49.92 kWh.',
    maxModules: 6,
  },
};
